<script>
/**
 * podemos pasar estas props si queremos que el contenedor del skeleton tenga dimensiones manuales
 * para poder aprovechar estas props, es necesario que la prop "has_manual_dimensions" este en true
 */
export let width = "100%";
export let height = "100%";

export let min_height = "";

/**
 * define si el contenedor skeleton tendra dimensiones manuales o no
 */
export let has_manual_dimensions = false;

/**
 * define el tipo de skeleton. 
 * Por ahora estan estas opciones: `table`
 */
export let type = null;

/**
 * si la prop type esta definida en `table` con esta prop podemos definir el numero de filas que 
 * renderizara el skeleton
 */
export let count = 1;

/**
 * define hasta cuando terminara de mostrarse el skeleton
 */
export let is_loaded = false;

/**
 * @type HTMLElement
 */
let container = null;

/**
 * @type HTMLElement
 */
let skeleton  = null;

let dimensions = { 
    width, height 
};

$: {
    if(container !== null && skeleton !== null && !has_manual_dimensions){
        let childToObserve = container.children[1];

        if(childToObserve){            
            let { width: widthBounding, height: heightBounding } = childToObserve.getBoundingClientRect();
            childToObserve.classList.add('is-hidden-sk');

            /* Tenemos en cuenta los paddings del contenedor y le restamos esos paddings 
                a las dimensiones finales que tendra el contenedor skeleton
            */
            const paddings = window.getComputedStyle(childToObserve).padding.split(" ");
            const margins = window.getComputedStyle(childToObserve).margin.split(" ");

            let [yPadding, xPadding] = paddings;
            let [yMargin, xMargin] = margins;

            //console.log({x, y, width, heightBounding});

            yPadding = yPadding?.replace("px", "") ?? 0;
            xPadding = xPadding?.replace("px", "") ?? 0;
            
            yMargin = yMargin?.replace("px", "") ?? 0;

            dimensions = { 
                width: `calc(100% - ${xPadding}px)`, 
                height: type === "table" ? "25px" : (heightBounding - (yPadding - (yMargin * 2))) + "px"
            };
        }
    }
} 

$: {
    if(container !== null){
        let childToObserve = container.children[1];
        childToObserve.classList.add('is-hidden-sk');
    }
}

$: {
    if(container !== null && skeleton !== null && is_loaded){
        complete_loaded();
    }
}

function complete_loaded(){
    let childToObserve = container.children[1];
    
    skeleton.style.zIndex = "-1";
    skeleton.remove();
    childToObserve.classList.remove('is-hidden-sk');
}

/* Testing purposes */
function mutationObserver(element){
    const config = { attributes: true, childList: false, subtree: true, characterData: true };

    const observer = new MutationObserver((mutationList, observer) => {
        skeleton.style.zIndex = "-1";
        skeleton.remove();
        observer.disconnect();
        element.classList.remove('is-hidden-sk');
    });

    observer.observe(element, config);
}


</script>

{#if type !== "table"}
    <skeleton-container class="container-skeleton {$$props.class}" bind:this={container}>
        <div class="skeleton" style="max-width: {dimensions?.width} !important; height: {dimensions?.height}; min-height: {min_height}" bind:this={skeleton}></div>
        {#if $$slots.default}
            <slot></slot>
            {:else}
                <span></span>
        {/if}
    </skeleton-container>
{/if}
    
{#if type === "table"}
    {#each Array.from({length: count + 1}).fill(count + 1) as item}
        <skeleton-container class="container-skeleton is-table {$$props.class}" bind:this={container}>
            <div class="skeleton" style="max-width: {dimensions?.width} !important; height: {dimensions?.height}" bind:this={skeleton}></div>
            <div></div>
        </skeleton-container>
    {/each}
{/if}

<style>
.container-skeleton{
    display: contents;
    width: 100%;
    position: relative;
    overflow: hidden;
}

.container-skeleton.is-table:not(:last-child){
    display: block;
    margin-bottom: 30px;
}

.skeleton {
    background-color: var(--color-extralightGrey);
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, .5),
        rgba(255, 255, 255, 0)
    ) var(--color-extralightGrey);
    background-size: 70px 100%;
    background-position-x: 180%;
    background-repeat: no-repeat;
    animation: 1.5s loading ease-in-out infinite;
    z-index: 10;
    border-radius: 12px;
    width: 100%;
}
.container-skeleton:global( .is-hidden-sk){
    pointer-events: none !important;
    position: absolute !important;
    /* display: none !important; */
    opacity: 0 !important;
}

@keyframes loading {
    from{
        background-position-x: -50%;
    }
    to {
        background-position-x: 150%;
    }
}
</style>